import checkProductExists from './check-product-exists';
import getProductID from './get-product-id';

export default async (wishlistProducts) => {
  let count_whishlist_items = 0;
  let count_notfound_items = 0;

  for (const wishlistProduct of wishlistProducts) {
    const product_exists = await checkProductExists(wishlistProduct.du);
    const wishlist_product_id = getProductID(wishlistProduct);

    if (!product_exists) {
      count_notfound_items++;

      if (window._swat) {
        const remove_object = window.wishlist_products.find(obj => obj.id === wishlist_product_id);

        if (typeof remove_object !== 'undefined') {
          window._swat.removeFromWishList(remove_object, () => {
            const el = document.querySelector(`[data-cart-wishlist-item-id="${wishlist_product_id}"]`);
            if (el) el.remove();
          });
        }
      }
    }

    count_whishlist_items++;

    if (count_notfound_items && count_whishlist_items === wishlistProducts.length) {
      // Remove 'new-row' class from all wishlist items
      document.querySelectorAll('[data-cart-wishlist-item]').forEach(item => {
        item.classList.remove('new-row');
      });

      // Add 'new-row' class every 4th item
      let count_whishlist_rendered_item = 0;
      document.querySelectorAll('[data-cart-wishlist-item]').forEach(item => {
        if (count_whishlist_rendered_item % 4 === 0) {
          item.classList.add('new-row');
        }
        count_whishlist_rendered_item++;
      });
    }
  }
};
